import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ToastService } from '@services/toast.service';

@Component({
  selector: 'app-snackbar-host',
  template: `
    <div class="snackbar-host" aria-live="polite">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="snackbar"
          [class.snackbar--success]="toast.variant === 'success'"
          [class.snackbar--error]="toast.variant === 'error'"
          [attr.role]="toast.variant === 'error' ? 'alert' : 'status'"
        >
          <i
            class="ph snackbar__icon"
            [class.ph-warning-circle]="toast.variant === 'error'"
            [class.ph-check-circle]="toast.variant !== 'error'"
            aria-hidden="true"
          ></i>
          <span class="snackbar__label">{{ toast.message }}</span>
          <button class="snackbar__action" type="button" (click)="toastService.dismiss(toast.id)">
            {{ toast.action }}
          </button>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarHost {
  protected readonly toastService = inject(ToastService);
}
